import { useNavigate } from "react-router-dom";
import "../../assets/css/product.scss";
import ProductStep2Component from "../../components/product/step2_component";
import { useEffect } from "react";
import { SessionStorageUtil } from "../../utils/session_storage_util";

function ProductStep2Page() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!SessionStorageUtil.getItem("accessToken")) {
      navigate("/product_step1", { replace: true });
    }
  }, [navigate]);

  if (!SessionStorageUtil.getItem("accessToken")) {
    return null;
  }

  return <ProductStep2Component />;
}

export default ProductStep2Page;
